import * as RouterActionTypes from './action-types.constants';
import * as RouterActions from './main-router.actions';
import * as WebViewActions from '@medscape-promo/medscapetv/web-view/web-view.actions';
import * as PlayerActionTypes from '../player/action-types.constants';
import * as IfiTemplateActionTypes from '../templates/ifi/action-types.constants';

function changeNextRoute(storeAPI, router) {
    const state = storeAPI.getState();
    const { configs, "series-path": seriesPath } = state.Main;
    const currentIndex = configs.findIndex(item => {
        return `${seriesPath}${item.path}` === router.history.location.pathname;
    })
    const nextConfig = configs[currentIndex + 1];
    if (nextConfig != null && nextConfig.comingsoon === false) {
        const nextPath = `${seriesPath}${nextConfig.path}`;
        router.history.push(nextPath);
        return true;
    } else {
        return false;
    }

}


function handleRouterReady(storeAPI, router) {
    router.history.listen(function(location, action) {
        //const state = storeAPI.getState();
        storeAPI.dispatch(RouterActions.historyLocationChange(location));
    })
    const state = storeAPI.getState();
    if(window.s_not_pageview == "y") {
        storeAPI.dispatch(WebViewActions.trackPageView(document.location));
    }
    //console.log("[MainRouter Middleware] state.WebView:",state.WebView);
    storeAPI.dispatch(WebViewActions.postCp(state.WebView.tracking.CP));
}

function handleHistoryLocationChange(storeAPI, location) {
    storeAPI.dispatch(WebViewActions.updateLocation(location));
    storeAPI.dispatch(WebViewActions.trackPageView(location));
}

function handleCloseIfiModal(storeAPI, router) {
    let hasNextRoute = changeNextRoute(storeAPI, router);
    if (hasNextRoute === false) {
        const state = storeAPI.getState();
        const { "series-path": seriesPath } = state.Main;
        router.history.push(seriesPath);
    }
}
const MainRouterMiddleware = (storeAPI) => {
    let router = null;
    return next => action => {
        //const state = storeAPI.getState();
        let result = next(action);
        //const nextState = storeAPI.getState();
        switch (action.type) {

            case RouterActionTypes.READY:
                router = action.BrowserRouter;
                handleRouterReady(storeAPI, action.BrowserRouter)
                break;
            case RouterActionTypes.HISTORY_LOCATION_CHANGE:
                handleHistoryLocationChange(storeAPI, action.location);
                break;
            case RouterActionTypes.CHANGE_LOCATION:
                router.history.push(action.path);
                break;
            case PlayerActionTypes.PLAYER_EVENT_ENDED:
                // NOTE: Need to wait for other video ended event handlers to execute before changing routes
                window.setTimeout(() => {
                    changeNextRoute(storeAPI, router);
                }, 10)
                break;
            case IfiTemplateActionTypes.CLOSE_IFI_MODAL:
                handleCloseIfiModal(storeAPI,router);
                break;
        }
        return result
    }

}

export default MainRouterMiddleware;